var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Account/Security") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 19.8227 0 19.8227 16.305 0 16.305"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Account/Security",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(3.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 8.694700)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.402,16.305 L3.421,16.305 C1.534,16.305 0,14.859 0,13.08 L0,11.534 C0,10.981 0.447,10.534 1,10.534 C1.552,10.534 2,10.981 2,11.534 L2,13.08 C2,13.755 2.637,14.305 3.421,14.305 L16.402,14.305 C17.185,14.305 17.823,13.755 17.823,13.08 L17.823,3.225 C17.823,2.55 17.185,2 16.402,2 L3.421,2 C2.637,2 2,2.55 2,3.225 L2,6.409 C2,6.962 1.552,7.409 1,7.409 C0.447,7.409 0,6.962 0,6.409 L0,3.225 C0,1.447 1.534,0 3.421,0 L16.402,0 C18.289,0 19.823,1.447 19.823,3.225 L19.823,13.08 C19.823,14.859 18.289,16.305 16.402,16.305",
    id: "Fill-1",
    fill: "#282827"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.2253,8.695 L13.5973,8.695 L13.5973,5.686 C13.5973,3.653 11.9443,2 9.9123,2 C7.8783,2 6.2253,3.653 6.2253,5.686 L6.2253,8.695 Z M15.5973,10.695 L4.2253,10.695 L4.2253,5.686 C4.2253,2.55 6.7763,0 9.9123,0 C13.0463,0 15.5973,2.55 15.5973,5.686 L15.5973,10.695 Z",
    id: "Fill-4",
    fill: "#282827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9113,19.4832 C10.6063,19.4832 11.2073,19.2232 11.6993,18.7132 C12.1893,18.2022 12.4373,17.5952 12.4373,16.9092 C12.4373,16.2282 12.1913,15.6022 11.7063,15.0512 C11.2153,14.4942 10.6113,14.2112 9.9113,14.2112 C9.2103,14.2112 8.6063,14.4942 8.1153,15.0512 C7.6313,15.6032 7.3853,16.2282 7.3853,16.9092 C7.3853,17.6162 7.6333,18.2282 8.1253,18.7302 C8.6153,19.2302 9.2163,19.4832 9.9113,19.4832",
    id: "Fill-6",
    fill: "#282827"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSecurity);
export default __webpack_public_path__ + "static/media/dashboard_security.95fd94ed426517734e5aee7b1d02c416.svg";
export { ForwardRef as ReactComponent };